
// Add this Tree component to your file
import React from "react";

export function Tree({ position }) {
    return (
        <group position={position} castShadow>
            {/* Tree trunk */}
            <mesh castShadow position={[0, 2, 0]}>
                <cylinderGeometry args={[0.5, 0.8, 4, 8]} />
                <meshStandardMaterial color="#8B4513" />
            </mesh>

            {/* Tree foliage - multiple layers for fuller look */}
            <mesh castShadow position={[0, 3.5, 0]}>
                <coneGeometry args={[3, 4, 8]} />
                <meshStandardMaterial color="#2E8B57" />
            </mesh>

            <mesh castShadow position={[0, 5, 0]}>
                <coneGeometry args={[2.2, 3, 8]} />
                <meshStandardMaterial color="#3CB371" />
            </mesh>

            <mesh castShadow position={[0, 6.5, 0]}>
                <coneGeometry args={[1.5, 2, 8]} />
                <meshStandardMaterial color="#32CD32" />
            </mesh>
        </group>
    );
}